import { useStore } from "@balm-ui";

export const title = "校园好声音";

export const getSchoolSelectProps = (textfieldAttrOrProp = {}) => {
  const $store = useStore();

  return {
    textfieldAttrOrProp,
    optionFormat: {
      label: "name",
      value: "id",
    },
    getOptionsFn: {
      province: () => $store.$getModelOptions("base-province"),
      city: ({ provinceId }) =>
        $store.$getModelOptions("base-city", { provinceId }),
      school: (provinceId, cityId) =>
        $store.$getModelOptions("base-school", {
          provinceId,
          cityId,
        }),
    },
    // getSchoolFn: async (schoolId) => {
    //   const { name } = await $store.$getModel(
    //     "base",
    //     { id: schoolId },
    //     { apiAction: "schoolInfo" }
    //   );
    //   return name;
    // },
  };
};

export const getFileUploadProps = (
  type,
  fileFormat = {
    url: "url",
    name: "name",
  }
) => {
  const $store = useStore();

  return {
    fileFormat,
    uploadFn: (file) => $store.upload(type, file),
  };
};
